import { createCarousel } from "./components/carousel";
import { createLoopProduct } from "./components/loop-product";
import { createNavbar } from "./components/header/navbar";
import { createSearchBar } from "./components/header/search-bar";
import { addToCart } from "./services/cart";
import { createCartPopup } from "./components/cart-popup";
import { createTopbar } from "./components/header/topbar";
import { getCartCount } from "./services/cart";
import { createLanguageSwitcher } from "./components/header/language-switcher";
import { createAccordion } from "./components/accordion";
import { ContactForm } from "./components/form/contact-form";
import { QuoteFormManager } from "./components/form/quote-form";
import { createCheckoutCouponForm } from "./components/checkout/coupon-form";

jQuery(function ($) {
  const components = {
    navbar: createNavbar($("[data-component='navbar']")),
    topbar: createTopbar($("[data-component='topbar']")),
    languageSwitcher: createLanguageSwitcher(
      $("[data-component='language-switcher']")
    ),
    accordion: createAccordion($("[data-component='accordion']")),
    forms: []
  };

  // Initialize checkout coupon form if it exists
  if ($("[data-component='checkout-coupon-form']").length > 0) {
    components.checkoutCouponForm = createCheckoutCouponForm(
      $("[data-component='checkout-coupon-form']")
    );
  }

  // Initialize accordions
  $("[data-component='accordion']").each((_, element) => {
    createAccordion(element);
  });

  // Initialize contact forms
  $("[data-component='contact-form'], .js-contact-form").each((_, element) => {
    const form = new ContactForm(element);
    components.forms.push(form);
  });

  // Initiate 2 search bars
  components.searchBar = createSearchBar($("[data-component='search-form']"));
  components.mobileSearchBar = createSearchBar(
    $("[data-component='search-form-mobile']")
  );

  // Update cart count dynamically
  getCartCount().then((count) => {
    $(".js-cart-count").text(count);
  });

  // Add search toggle click handler for smaller screens
  components.navbar.addSearchToggleClickHandler(() => {
    components.mobileSearchBar.toggle();
    const isOpen = components.mobileSearchBar.isOpen;
    components.navbar.toggleSearchBarToggler(isOpen);
  });

  // Function to initialize carousels
  const initializeCarousel = (element) => {
    createCarousel(element, {
      onCloneItems: function (clones) {
        if (clones.length === 0) return;
        clones.each((index, clone) => {
          const $loopProduct = jQuery(clone).find(
            "[data-component='loop-product']"
          );
          if ($loopProduct.length > 0) {
            createLoopProduct($loopProduct[0]);
          }
        });
      },
    });
  };

  // Initialize existing carousels
  $("[data-component='carousel']").each((_, element) =>
    initializeCarousel(element)
  );

  // Event delegation for add to cart buttons
  $(document).on(
    "click",
    '[data-component="loop-product"] .js-add-to-cart-button',
    async function (e) {
      e.preventDefault();
      const $productElement = $(this).closest(
        '[data-component="loop-product"]'
      );
      const loopProduct = createLoopProduct($productElement[0]);

      try {
        loopProduct.loading();
        if (!loopProduct.disableCartPopup) {
          createCartPopup(loopProduct.productId);
        }
        await addToCart(loopProduct.productId);
        loopProduct.done();
        loopProduct.hideAddToCartButton();
        loopProduct.showVisitCartButton();
      } catch (error) {
        console.error("Error adding to cart:", error);
        loopProduct.done();
      }
    }
  );

  // Observer for dynamically added components
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Check for new carousels
          const carousels = node.querySelectorAll(
            '[data-component="carousel"]'
          );
          carousels.forEach((carousel) => initializeCarousel(carousel));

          // Check for new accordions
          const accordions = node.querySelectorAll(
            '[data-component="accordion"]'
          );
          accordions.forEach((accordion) => createAccordion(accordion));
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Initialize quote form manager if there are quote buttons on the page
  if ($(".js-quote-request-button").length > 0) {
    components.quoteFormManager = new QuoteFormManager();
  }
});
